'use client';
import useInitializeCheckUser from './useInitializeCheckUser';
import useInitializeCurrentAccount from './useInitializeCurrentAccount';
import useInitializeFetchAccount from './useInitializeFetchAccount';
import useInitializeFetchAccountIdentities from './useInitializeFetchAccountIdentities';
import useInitializeFetchStats from './useInitializeFetchStats';
import useInitializeFetchSubAccounts from './useInitializeFetchSubAccounts';
import useInitializeFetchUser from './useInitializeFetchUser';
import useInitializeFirebaseAuth from './useInitializeFirebaseAuth';
import useInitializeTokenSync from './useInitializeTokenSync';

const useInitialization = () => {
  useInitializeFirebaseAuth();
  useInitializeTokenSync();
  useInitializeCheckUser();
  useInitializeFetchUser(); // Sets rootAccounts
  useInitializeCurrentAccount(); // Sets currentAccountId from rootAccounts - MUST run after useInitializeFetchUser
  useInitializeFetchAccount(); // Needs currentAccountId
  useInitializeFetchSubAccounts();
  useInitializeFetchAccountIdentities();
  useInitializeFetchStats();
};

export default useInitialization;
